import React from 'react';
import { Link } from 'react-router-dom';

export const Footer: React.FC = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-sidebar text-primary-100">
      <div className="container-width section-padding py-14">
        <div className="grid gap-10 md:grid-cols-[1.4fr_1fr_1fr]">
          <div>
            <div className="mb-4 flex items-center gap-2.5">
              <img src="/images/SynqTag.svg" alt="" className="h-8 w-8" />
              <span className="font-display text-xl text-white">SynqTag</span>
            </div>
            <p className="max-w-sm text-sm leading-relaxed text-primary-200">
              Work items, pages, time, and a portfolio across workspaces. Built for delivery teams that
              keep more than one client in the air.
            </p>
          </div>
          <div>
            <h2 className="mb-3 font-sans text-xs font-semibold uppercase tracking-[0.14em] text-primary-300">
              Product
            </h2>
            <ul className="space-y-2 text-sm">
              <li><Link className="hover:text-white" to="/features">Features</Link></li>
              <li><Link className="hover:text-white" to="/product-tour">Product tour</Link></li>
              <li><Link className="hover:text-white" to="/pricing">Pricing</Link></li>
              <li><Link className="hover:text-white" to="/roadmap">In the product</Link></li>
            </ul>
          </div>
          <div>
            <h2 className="mb-3 font-sans text-xs font-semibold uppercase tracking-[0.14em] text-primary-300">
              Company
            </h2>
            <ul className="space-y-2 text-sm">
              <li><Link className="hover:text-white" to="/about">About</Link></li>
              <li><Link className="hover:text-white" to="/contact">Contact</Link></li>
              <li><Link className="hover:text-white" to="/use-cases">Use cases</Link></li>
              <li><a className="hover:text-white" href="mailto:team@synqtag.com">team@synqtag.com</a></li>
            </ul>
          </div>
        </div>
        <div className="mt-12 flex flex-col gap-3 border-t border-white/10 pt-6 text-sm text-primary-300 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} SynqTag</p>
          <div className="flex flex-wrap gap-x-5 gap-y-2">
            <Link className="hover:text-white" to="/privacy">Privacy</Link>
            <Link className="hover:text-white" to="/terms">Terms</Link>
            <a className="hover:text-white" href="https://deesha.tech" target="_blank" rel="noopener noreferrer">
              Built by Deesha Tech
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
